var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHydrant = function SvgHydrant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.991 180.072h50.016V422h-50.016zM200.991 422V180.072h-50.015v30.096H90.928v45.036h-30v30h30v45.036h60.048V422zM150.976 452v30h-30v30h270.048v-30h-30v-30zM391.024 150.072v-30h-31.073C353.364 74.131 316.937 37.698 271 31.1V0h-30v31.1c-45.937 6.599-82.363 43.032-88.951 88.972h-31.072v30zM451.072 255.204h-30v-45.036h-60.048v-30.096h-50.016V422h50.016v-91.76h60.048v-45.036h30z"
  })));
};
export default SvgHydrant;